var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassSurveyAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.438 178.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 583",
    d: "M86.719 16.765a72.689 72.689 0 1072.688 72.689A72.689 72.689 0 0086.72 16.765zm7.55 120.718H79.505v-14.156h14.764zm-.354-78.55l-1.417 40.988c0 2.126 0 3.78-.119 4.724v2.009c0 1.29.119 4.134.237 6.36H80.93a52.32 52.32 0 00.354-5.897c0-1.89 0-1.89-.236-7.205l-1.3-40.987c-.236-4.97-.472-10.159-.908-13.83h15.946c-.518 4.498-.754 9.105-.872 13.839z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassSurveyAlert);
export default __webpack_public_path__ + "static/media/class-survey-alert.7505ff3f.svg";
export { ForwardRef as ReactComponent };